import React, { useState } from "react";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import "./sendEmailAgain.scss";
import axiosInstance from "../../axios";
import CheckIcon from "../../assets/images/check-icon.png";

import { Loading } from "../Other/Loading";
import { history } from "../../_helpers";
import { useDispatch } from "react-redux";
import { errorActions } from "../../_actions";
import { useNavigate } from "react-router-dom";

const SendEmailAgain = ({
  isloading,
  setIsLoading,
  handleCloseVerification,
  setResendVerification,
  email,
  time,
  setTime,
  loginInfo,
  setLoginInfo
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleResendLink = async () => {
    if (time > 0) return;

    setIsLoading(true);

    try {
      const res = await axiosInstance.post("/get-verification-link", { email });

      if (!res?.data?.error) {
        setTime(120);
      }
    } catch (err) {
      console.error("Error resending verification link:", err.message);
      // Optionally show an error toast or message
    } finally {
      setIsLoading(false);
    }
  };


  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secondsRemaining = seconds % 60;
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(secondsRemaining).padStart(2, "0");
    return `${formattedMinutes}:${formattedSeconds}`;
  };

  const closeResendWrapper = () => {
    setResendVerification(false);
    navigate("/login");
    dispatch(errorActions.hideError());
    setLoginInfo({ ...loginInfo, fetch: !loginInfo.fetch });
  };

  return (
    <OverlayContainer>
      <div className="send-email-dialog-inner">
        <div className="send-email-heading">
          <div className="send-email-title">
            <h2>Verification email sent</h2>
          </div>
          <div
            className="send-email-dialog-close"
            onClick={handleCloseVerification}
          >
            <div>
              <i className="icon check"></i>
            </div>
          </div>
        </div>
        <div className="send-email-message-2">
          <p>
            We have sent a verification email on your email address{" "}
            <b>"{`${email}`}".</b> Please check your “Spam” folder. You can also
            click the resend button below to have another email sent to you.
          </p>
        </div>
        <div className="send-email-close-btn">
          <button onClick={closeResendWrapper}>OKAY</button>
        </div>
        {isloading ? (
          <Loading />
        ) : (
          <div className="send-confirm-sent-message">
            <div
              className={
                !time > 0 ? "resend-email-title" : "resend-email-disabled"
              }
              onClick={handleResendLink}
            >
              <p>
                Need to send verification link again?
                {time === 0 ? (
                  <span>Resend Now</span>
                ) : (
                  <span id="format-time">
                    Resend in
                    <span>{formatTime(time)}</span>
                  </span>
                )}
              </p>
            </div>
          </div>
        )}
      </div>
    </OverlayContainer>
  );
};

export default SendEmailAgain;
